// deviationUtils.js

/**
 * Validates and retrieves the applicable rate formatted to two decimals.
 */
export const checkRevisedRate = (details, returnValue, checkValidation, getTwoDigitDecimal) => {
    const isValidRate = (val) => checkValidation(val) && val !== 0;
    const validRate = [details?.revised_rate, details?.prev_ra_rate].find(isValidRate);

    return validRate !== undefined ? getTwoDigitDecimal(validRate) : returnValue;
};

/**
 * Calculates updated quantity and excess quantity based on contract parameters and state constraints.
 */
export const calculateEligibleQuantityForDeviation = (
    totalContractQuantity,
    contractRate,
    isPositiveDeviation,
    state,
    getTwoDigitDecimal
) => {
    const totalQty = getTwoDigitDecimal(totalContractQuantity);
    const rate = getTwoDigitDecimal(contractRate);
    const variance = getTwoDigitDecimal(state?.variance);
    const initialAmount = getTwoDigitDecimal(state?.initial_contract_amount);
    const excessInitial = getTwoDigitDecimal(state?.excess_initial_contract);

    const appliedVariance = getTwoDigitDecimal(totalQty * variance) / 100;
    const deviationSign = isPositiveDeviation ? 1 : -1;

    const excessAmount = getTwoDigitDecimal(initialAmount * excessInitial) / 100;
    const excessQuantity = rate !== 0 ? getTwoDigitDecimal(excessAmount / rate) : 0;

    const updatedQuantity = getTwoDigitDecimal(totalQty + (deviationSign * appliedVariance) + excessQuantity);

    return {
        updatedQuantity,
        excessQuantity
    };
};


export const formatRaBillNo = (projectDetails) => {
    if (!projectDetails || !projectDetails.rabill_no) {
        return "";
    }
    return `${projectDetails.rabill_no}${projectDetails.final_bill ? " (Final Bill)" : ""}`;
}

